import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { userRole } from '../store/selectors/auth.selector';
import getItemFromLocalStorage from '../utils/getItemFromLocalStorage';

const PrivateRoute = ({ component, path, url, routeRole }) => {
  const token = getItemFromLocalStorage('accessToken');
  const role = useSelector(userRole);
  if (!token) {
    return <Redirect to={{ pathname: '/' }} />;
  }
  if (routeRole === 'Administrator' || routeRole.includes(role)) {
    return <Route exact path={path} component={withRouter(component)} />;
  }
  return <Redirect to={{ pathname: `/dashboard` }} />;
};

export default PrivateRoute;